// Очередь тостов-реакций и мут-лист текущего матча (только память клиента).
// Всегда отображается первый элемент queue; по таймауту показа он удаляется
// (DEQUEUE_REACTION) — скрытые реакции в стейте не хранятся.
// ENQUEUE_OWN_REACTION диспатчит сам отправитель при отправке (noServerSync) —
// в том числе админ за перехваченного бота, эхо отправителю сервер не шлет;
// REACTION_RECEIVED приходит адресатам от сервера с серверной меткой через
// generic-ветку LobbyPage.onmessage (с _fromServer — обратно на сервер не зеркалится)

// Локальный порядковый id элементов очереди — нужен таймеру тоста, чтобы
// различать соседние реакции с одинаковым содержимым
let nextReactionQueueId = 1;

const initialState = {
  queue: [],
  mutedPlayerIds: [],
};

const enqueue = (state, {fromPlayerId, toPlayerId, reactionType}) => {
  const newItem = {id: nextReactionQueueId++, fromPlayerId, toPlayerId, reactionType};

  // Сейчас отображается реакция ЭТОГО ЖЕ игрока (queue[0]), за ней в очереди
  // никто не ждет, и новая реакция ДРУГОГО типа — заменяем показанную
  // мгновенно вместо постановки в конец очереди (иначе пришлось бы ждать
  // истечения таймера уже увиденной реакции). Если в очереди уже есть другие
  // реакции — обычная постановка в конец, как раньше
  const current = state.queue[0];
  const shouldReplaceCurrent = state.queue.length === 1
    && current
    && current.fromPlayerId === fromPlayerId
    && current.reactionType !== reactionType;

  return {
    ...state,
    queue: shouldReplaceCurrent ? [newItem] : [...state.queue, newItem],
  };
};

const reactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ENQUEUE_OWN_REACTION':
      return enqueue(state, action.payload);
    case 'REACTION_RECEIVED': {
      if (state.mutedPlayerIds.includes(action.payload.fromPlayerId)) {
        return state;
      }
      return enqueue(state, action.payload);
    }
    case 'DEQUEUE_REACTION':
      return {
        ...state,
        queue: state.queue.slice(1),
      };
    case 'MUTE_PLAYER_REACTIONS': {
      const {playerId} = action.payload;
      if (state.mutedPlayerIds.includes(playerId)) {
        return state;
      }
      return {
        ...state,
        mutedPlayerIds: [...state.mutedPlayerIds, playerId],
      };
    }
    default:
      return state;
  }
};

export default reactionsReducer;
